const localizers = {
  'loading.msg': () => `Caricamento...`,
  'SASServer.genericError.msg': () => `Impossibile raggiungere il server.`,
  'SASReport.genericError.msg': () => `Impossibile caricare il report selezionato.`,
  'SASReportImage.genericError.msg': () => `Impossibile caricare l’immagine del report.`,
  'SASReportImage.imageNotSupported.msg': () => `Le immagini non sono supportate per questo tipo di contenuto del report.`,
}
export default localizers;
